import React from 'react';
import PropTypes from 'prop-types';

import PersonImg from 'inside-out/images/medicare/person-2.png';

import {
	innerWrapperStyle,
	wrapperStyle,
	attendStyle,
	titleStyle,
	attendTitleStyle,
	textStyle,
} from 'inside-out/page-styles/medicare';

import {
	contentSection,
} from 'inside-out/global-styles';


const MedicareForMeStep3Page = () => (
  <div className={wrapperStyle}>
    <section className={contentSection()} id="level-3">
      <div className={innerWrapperStyle}>
        <header>
          <h1 className={titleStyle}>Visit your GP</h1>
        </header>
        <div className={textStyle}>
          <p>At or before your 10th psychological session, you will need to go back to your GP to review your treatment progress. At this point, the GP can approve a second course of 10 psychological sessions.</p>
        </div>
      </div>
    </section>

    <section className={contentSection('#fff')}>
      <div className={attendStyle}>
        <img src={ PersonImg } alt="" />
        <div>
          <h1 className={attendTitleStyle}>Attend Sessions 11-20</h1>
          <div className={textStyle}>
            <p> Many people with eating disorders will make positive progress and see good results within 20 sessions of evidence based treatment, and a number will even reach remission.   However, you may require longer term treatment, particularly if your illness is very longstanding, complex, or complicated by other factors.</p>
            <p>If you think you will need more than 20 sessions, then discuss booking the mandated 20 session review with a psychiatrist or peadiatritan with you mental health provider and GP, and book it if you have not already done so.</p>
          </div>
        </div>
      </div>
    </section>
  </div>
);

export { MedicareForMeStep3Page }



// WEBPACK FOOTER //
// ./src/components/medicare/for-me/step-3.js